"use strict";

function insertRule(e) {
  try {
    return sheet.insertRule(e, sheet.cssRules.length);
  } catch (e) {
    console.warn("react-reveal - animation failed");
  }
}

function cascade(e, n, t, o, r) {
  var i = Math.log(o),
      s = Math.log(r),
      a = (s - i) / (t - n);
  return Math.exp(i + a * (e - n));
}

function animation(e) {
  if (!sheet) return "";
  var n = "@keyframes " + (name + counter) + "{" + e + "}",
      t = effectMap[e];
  return t ? "" + name + t : (insertRule(n), effectMap[e] = counter, "" + name + counter++);
}

function hideAll() {
  globalHide || (exports.globalHide = globalHide = !0, window.removeEventListener("scroll", hideAll, !0), insertRule("." + namespace + " { opacity: 0; }"), window.removeEventListener("orientationchange", hideAll, !0), window.document.removeEventListener("visibilitychange", hideAll));
}

function config(e) {
  var n = e.ssrFadeout;
  exports.fadeOutEnabled = fadeOutEnabled = n;
}

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.insertRule = insertRule, exports.cascade = cascade, exports.animation = animation, exports.hideAll = hideAll, exports.default = config;

var namespace = exports.namespace = "react-reveal",
    defaults = exports.defaults = {
  duration: 1e3,
  delay: 0,
  count: 1
},
    ssr = exports.ssr = !0,
    observerMode = exports.observerMode = !1,
    raf = exports.raf = function (e) {
  return window.setTimeout(e, 66);
},
    disableSsr = exports.disableSsr = function () {
  return exports.ssr = ssr = !1;
},
    fadeOutEnabled = exports.fadeOutEnabled = !1,
    ssrFadeout = exports.ssrFadeout = function () {
  var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
  return exports.fadeOutEnabled = fadeOutEnabled = e;
},
    globalHide = exports.globalHide = !1,
    ie10 = exports.ie10 = !1,
    collapseend = exports.collapseend = void 0,
    counter = 1,
    effectMap = {},
    sheet = !1,
    name = namespace + "-" + Math.floor(1e15 * Math.random()) + "-";

if ("undefined" != typeof window && "nodejs" !== window.name && window.document && "undefined" != typeof navigator) {
  exports.observerMode = observerMode = "IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype && /\{\s*\[native code\]\s*\}/.test("" + IntersectionObserver), exports.raf = raf = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || raf, exports.ssr = ssr = window.document.querySelectorAll("div[data-reactroot]").length > 0, -1 !== navigator.appVersion.indexOf("MSIE 10") && (exports.ie10 = ie10 = !0), ssr && "performance" in window && "timing" in window.performance && "domContentLoadedEventEnd" in window.performance.timing && window.performance.timing.domLoading && Date.now() - window.performance.timing.domLoading < 300 && (exports.ssr = ssr = !1), ssr && window.setTimeout(disableSsr, 1500), observerMode || (exports.collapseend = collapseend = document.createEvent("Event"), collapseend.initEvent("collapseend", !0, !0));
  var element = document.createElement("style");
  document.head.appendChild(element), element.sheet && element.sheet.cssRules && element.sheet.insertRule && (sheet = element.sheet, window.addEventListener("scroll", hideAll, !0), window.addEventListener("orientationchange", hideAll, !0), window.document.addEventListener("visibilitychange", hideAll));
}